import { FC, ReactElement } from "react";

import { TextInput } from "../Inputs";
import { InputProps, useInput } from "./useInput";

interface Props extends InputProps<string> {
  label?: string | ReactElement;
  password?: boolean;
  disabled?: boolean;
  placeholder?: string;
  suffix?: string;
  readonly?: boolean;
  hideErrors?: boolean;
}

export const FormTextInput: FC<Props> = (props) => {
  const input = useInput({ ...props });

  return (
    <TextInput
      label={props.label}
      value={input.value}
      name={props.name}
      onChange={(value) => input.onChangeHandler(value)}
      disabled={props.disabled}
      placeholder={props.placeholder}
      onBlur={input.onBlurHandler}
      password={props.password}
      errors={input.isDirty ? input.errors : []}
      id={props.name}
      required={input.isRequired}
      suffix={props.suffix}
      data-testid="form-text"
      readonly={props.readonly}
      hideErrors={props.hideErrors}
    />
  );
};
